import { IconButton, Menu, MenuItem } from "@mui/material";
import React, { ReactNode } from "react";
import { AUTURA_ASPHALT_DARK, AUTURA_ASPHALT_LIGHT } from "utils";
import { MoreVert } from "@mui/icons-material";
import { MenuOption } from "./TableCellMenuButton";
interface ListItemMenuButtonProps {
  menuOptions: MenuOption[];
  unsetBorder?: boolean;
}
export const ListItemMenuButton = ({
  menuOptions,
}: ListItemMenuButtonProps): ReactNode => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState(false);
  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };
  const handleItemClick =
    (option: MenuOption) => (event: React.MouseEvent<HTMLLIElement>) => {
      event.stopPropagation();
      handleClose();
      option.onClick();
    };
  return (
    <>
      <IconButton disabled={!menuOptions.length} onClick={handleMenuClick}>
        <MoreVert
          htmlColor={
            !menuOptions.length ? AUTURA_ASPHALT_LIGHT : AUTURA_ASPHALT_DARK
          }
          fontSize={"small"}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          dense: true,
        }}
      >
        {menuOptions.map((option, index) => (
          <MenuItem
            key={index}
            onClick={handleItemClick(option)}
            disabled={option.disabled}
          >
            {option.content}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
